import React, { useState, useEffect } from 'react'
import { Row, Card, Typography } from 'antd'
import { EmptyHeaderHero, GlobalHeader, GlobalFooter, SEO } from './components'
import { getDomain, useWindowSize } from '../utils'
const { Link } = Typography

import SubmitDocStyle from '../../styles/SubmitDocuments.module.css'

const SubmitDocuments = () => {
  const windowSize = useWindowSize();
  const isMobile = windowSize.width <= 430;
  const [showMIModal, setShowMIModal] = useState(false)

  useEffect(() => {
    document.addEventListener('click', (e) =>
      {
        if(showMIModal) {
          let elementClass = e.target.className;
          if (elementClass.includes('mi-pop-up') || elementClass.includes('mi-modal-button')) {
            setShowMIModal(true);
          }
          else {
            setShowMIModal(false);
          }
        }
      }
    );
  }, [showMIModal]);

  //Redirect depending on state
  const handleState = (state) => {
    if (state == 'michigan') {
      setShowMIModal(true);
    }
    else {
      redirectToUploadPage(state);
    }
  }

  //Handle MI modal
  const handleMIRedirect = (type) => {
    if (type == 'renewal') {
      const newWindow = window.open('https://' + getDomain(type) + '/mi/Renewal_0Login', '_self', 'noopener, noreferrer')
      if (newWindow) newWindow.opener = null
    }
    else {
      redirectToUploadPage("michigan");
    }
  }

  //Redirect to Upload page
  const redirectToUploadPage = (state) => {
    const newWindow = window.open('/g/submit-documents/' + state + '-pip-document-upload', '_self', 'noopener, noreferrer')
    if (newWindow) newWindow.opener = null
  }

  return (
    <div className="container">
      <GlobalHeader />
      <>
        <SEO
          title={"Upload Insurance Documents | CURE Auto Insurance"} 
          description={"Securely submit your policy or claim documents online to CURE auto insurance."} 
          url={"/g/submit-documents"}
        />
        <EmptyHeaderHero className={`${SubmitDocStyle["EmptyHeaderHeroUploadDocs"]}`} leftAlign={true} minHeight={true} title="Submit Requested Files" />
        {isMobile && (
          <div style={{ height: '8px' }} />
        )}

        <div className={`${SubmitDocStyle["mi-pip-upload"]}`}>
          <Row>
            <Card>
              {/* Select your documents */}
              <Row className={`${SubmitDocStyle["description"]}`}>
                <span style={{ display:(!showMIModal ? 'flex' : 'none') }}>Please select your state below.</span>
              </Row>
              <div className={`${SubmitDocStyle["submit-documents-screen"]}`}>
                {/* Desktop */}
                { !isMobile ? 
                  <div className={`${SubmitDocStyle["submit-documents-drivers-row"]}`}>
                    {/* MI button */}
                    <div>
                      <Link className={`${SubmitDocStyle["mi-drivers"]} mi-pop-up-button`} onClick={() => handleState("michigan")}>
                        <img className={"mi-pop-up-button"} alt="mi-drivers" />
                      </Link>
                    </div>

                    {/* MI modal */}
                    <div className={`${SubmitDocStyle["mi-pop-up"]}`} style={{ display:(showMIModal ? 'flex' : 'none') }}>
                      <div className={`${SubmitDocStyle["mi-pop-up-container"]}`}>
                        <Row className={`${SubmitDocStyle["mi-pop-up-labels"]}`}>
                          <span className={`${SubmitDocStyle["mi-pop-up-span"]}`}>Time to renew your No-Fault PIP choice?</span> 

                          <a type="button" onClick={ () => handleMIRedirect("renewal") } className={`${SubmitDocStyle["mi-modal-button"]} btn btn-secondary btn-sm text-center`}>
                            <span className={`${SubmitDocStyle["mi-modal-button-span"]}`}>CLICK HERE</span>
                          </a>
                        </Row>
                        <Row className={`${SubmitDocStyle["mi-pop-up-labels"]}`}>
                          <span className={`${SubmitDocStyle["mi-pop-up-span"]}`}>Simply need to upload a document?</span>

                          <a type="button" onClick={ () => handleMIRedirect("upload") } className={`${SubmitDocStyle["mi-modal-button"]} btn btn-secondary btn-sm text-center`}>
                            <span className={`${SubmitDocStyle["mi-modal-button-span"]}`}>UPLOAD</span>                          
                          </a>
                        </Row>
                      </div>
                    </div>

                    {/* Other buttons */}
                    <div className='other-states' style={{ display:(!showMIModal ? 'flex' : 'none') }}>
                      <div>
                        <Link className={`${SubmitDocStyle["nj-drivers"]}`} onClick={() => handleState("new-jersey")}>
                          <img alt="nj-drivers" />
                        </Link>
                      </div>
                      <div>
                        <Link className={`${SubmitDocStyle["pa-drivers"]}`} onClick={() => handleState("pennsylvania")}>
                          <img alt="pa-drivers" />
                        </Link>
                      </div>
                    </div>
                  </div>
                :
                  <div>
                    {/* Mobile */}
                    {/* MI button */}
                    <div className={`${SubmitDocStyle["mi-container-mobile"]}`}>
                      <Link className={`${SubmitDocStyle["mi-drivers"]}`} onClick={() => handleState("michigan")}>
                        <img className={"mi-pop-up-button"}  alt="mi-drivers" />
                      </Link>
                    </div>

                    {/* MI modal */}
                    <div className='text-center' style={{ display:(showMIModal ? 'block' : 'none'), marginTop:'40px' }}>
                      <div className={`${SubmitDocStyle['mi-pop-up-container']}`}>
                        <div style={{ margin: '15px 0' }}>
                          <span className={`${SubmitDocStyle["mi-pop-up-span"]}`} style={{ fontSize: '20px' }}>Time to renew your No-Fault PIP choice?</span>
                          <br />
                        </div>
                        <div>
                          <a type="button" onClick={ () => handleMIRedirect("renewal") } className={`${SubmitDocStyle["mi-modal-button"]} btn btn-secondary btn-sm text-center`}>
                            <span className={`${SubmitDocStyle["mi-modal-button-span"]}`}>CLICK HERE</span>
                          </a>
                        </div>
                      </div>
                      <div className={`${SubmitDocStyle['mi-pop-up-container']}`}>
                        <div style={{ margin: '15px 0' }}>
                          <span className={`${SubmitDocStyle["mi-pop-up-span"]}`} style={{ fontSize: '20px' }}>Simply need to upload a document?</span>
                          <br />
                        </div>
                        <div style={{ marginBottom: '30px' }}>
                          <a type="button" onClick={ () => handleMIRedirect("upload") } className={`${SubmitDocStyle["mi-modal-button"]} btn btn-secondary btn-sm text-center`}>
                            <span className={`${SubmitDocStyle["mi-modal-button-span"]}`}>UPLOAD</span>                          
                          </a>
                        </div>
                      </div>
                    </div>

                    {/* Other buttons */}
                    <div className='other-states' style={{ display:(!showMIModal ? 'block' : 'none') }}>
                      <div className={`${SubmitDocStyle["nj-container-mobile"]}`}>
                        <Link className={`${SubmitDocStyle["nj-drivers"]}`} onClick={() => handleState("new-jersey")}>
                          <img alt="nj-drivers" />
                        </Link>
                      </div>
                      <div className={`${SubmitDocStyle["pa-container-mobile"]}`}>
                        <Link className={`${SubmitDocStyle["pa-drivers"]}`} onClick={() => handleState("pennsylvania")}>
                          <img alt="pa-drivers" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  }
              </div>
            </Card>
          </Row>
        </div>

        {/* <Modal
          className='mi-document-modal'
          bodyStyle={{ 
            padding: '10px'
          }}
          onCancel={() => setShowMIModal(false)}
          visible={showMIModal}
          footer={null}
        >
          <Row style={{ marginBottom: '10px' }}>
            <a type="button" onClick={ () => handleMIRedirect("renewal") } className="mi-modal-button btn btn-secondary btn-sm text-center">
              <span>CLICK HERE FOR RENEWALS</span>
            </a>
          </Row>
          <Row>
            <a type="button" onClick={ () => handleMIRedirect("upload") } className="mi-modal-button btn btn-secondary btn-sm text-center">
              <span>CLICK HERE FOR UPLOADS</span>
            </a>
          </Row>
        </Modal> */}
      </>
      <GlobalFooter />
    </div>
  )
}

export default SubmitDocuments


